module.exports = __webpack_public_path__ + "img/DE02809.f3496317.png";